import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, type TypedUseSelectorHook, useSelector } from 'react-redux';

import { stepsSlice } from './stepsSlice';
import { plansSlice } from './plansSlice';
import { couponSlice } from './couponSlice';
import { authFormSlice } from './authFormSlice';
import { initSlice } from '@/store/new-order/initSlice';
import { notificationsSlice } from '@/store/new-order/notificationsSlice';
import { submitSlice } from '@/store/new-order/submitSlice';
import { userSlice } from '@/store/new-order/userSlice';
import { flagsSlice } from './flagsSlice';
import { featureFlagsSlice } from '@/store/featureFlagsSlice';

export const affilateStore = configureStore({
  reducer: {
    [initSlice.name]: initSlice.reducer,
    [stepsSlice.name]: stepsSlice.reducer,
    [plansSlice.name]: plansSlice.reducer,
    [notificationsSlice.name]: notificationsSlice.reducer,
    [couponSlice.name]: couponSlice.reducer,
    [authFormSlice.name]: authFormSlice.reducer,
    [submitSlice.name]: submitSlice.reducer,
    [userSlice.name]: userSlice.reducer,
    [flagsSlice.name]: flagsSlice.reducer,
    [featureFlagsSlice.name]: featureFlagsSlice.reducer,
  },
});

export type AffiliateRootState = ReturnType<typeof affilateStore.getState>;

export type AffiliateDispatch = typeof affilateStore.dispatch;
export const useAffiliateDispatch: () => AffiliateDispatch = useDispatch;
export const useAffiliateSelector: TypedUseSelectorHook<AffiliateRootState> = useSelector;
